"use client";
import { useEffect, useRef, useState } from "react";
import { Control, Controller, FieldErrors } from "react-hook-form";
import InputFile from "../../InputFile";
import "./style.css";

interface Props {
  name: string;
  label?: string;
  control: Control<any, any>;
  errorProp?: string | FieldErrors;
  required?: boolean;
  disabled?: boolean;
  accept?: string;
  maxSize?: number; // in MB
  multiple?: boolean;
  inline?: boolean; // Makes the input display clickable, hiding the separate button
  placeholder?: string;
  chooseLabel?: string;
  removeLabel?: string;
  changeLabel?: string;
  containerClassName?: string;
  className?: string;
  onCustomChange?: (file: File | File[] | null) => void;
}

const ControlledInputFile = ({
  name,
  label,
  control,
  errorProp,
  required,
  disabled,
  accept,
  maxSize,
  multiple,
  inline,
  placeholder,
  chooseLabel,
  removeLabel,
  changeLabel,
  containerClassName,
  className,
  onCustomChange,
}: Props) => {
  const getErrorMessage = (): string | undefined => {
    if (!errorProp) return undefined;

    if (typeof errorProp === "string") {
      return errorProp;
    }

    // Navega pela estrutura aninhada de erros usando o caminho do name
    // Ex: "address.street" -> error.address.street
    if (typeof errorProp === "object") {
      const nameParts = name.split(".");
      let currentError: any = errorProp;

      for (const part of nameParts) {
        if (currentError && typeof currentError === "object" && part in currentError) {
          currentError = currentError[part];
        } else {
          return undefined;
        }
      }

      return currentError?.message as string | undefined;
    }

    return undefined;
  };

  const errorMessage = getErrorMessage();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value } }) => (
        <InputFile
          name={name}
          label={label}
          value={value}
          error={errorMessage}
          required={required}
          disabled={disabled}
          accept={accept}
          maxSize={maxSize}
          multiple={multiple}
          inline={inline}
          placeholder={placeholder}
          chooseLabel={chooseLabel}
          removeLabel={removeLabel}
          changeLabel={changeLabel}
          containerClassName={containerClassName}
          className={className}
          onChange={(file) => {
            onChange(file);
            onCustomChange && onCustomChange(file);
          }}
        />
      )}
    />
  );
};

export default ControlledInputFile;
